import React from 'react';
import { useTranslation } from 'react-i18next';

import { IncludeButtonProps } from './interfaces';
import { Container, Title } from './styles';

const IncludeButton: React.FC<IncludeButtonProps> = ({
  callback,
  title,
  style,
  disabled,
  className,
}) => {
  const { t } = useTranslation();
  return (
    <Container
      onClick={callback}
      style={style}
      className={`includeButton ${className}`}
      disabled={!!disabled}
    >
      {/* <Title style={titleStyle} className={className}> */}
      <Title className={className}>{t(title)}</Title>
    </Container>
  );
};

export default IncludeButton;
